import { PromoCodesList as PromoCodesListComponent } from 'components/promoCodes/PromoCodesList/PromoCodesList'

export const ProfilePromocodesList: React.FC = () => {
  return <PromoCodesListComponent />
}
